import { Epic, ofType } from 'redux-observable';
import { concat, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { getType } from 'typesafe-actions';

import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';
import { hideBusy, showBusy } from '../CanvasApp/actions';
import { CanvasAction } from '../common/actions';

import { LoadPresets, loadPresets, loadPresetsSuccess, showError } from './actions';
import { createPresetsList } from './mappers';

export const loadPresetsEpic: Epic<CanvasAction, CanvasAction, State, EpicDeps> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(getType(loadPresets)),
        switchMap((action: LoadPresets) => {
            const sharedData = store$.value.canvasEditor.sharedData;

            return concat(
                of(showBusy()),
                from(deps.canvasApi.presets.get(sharedData)).pipe(
                    map(result => createPresetsList(result)),
                    map(collection => loadPresetsSuccess(collection)),
                    catchError(error => of(showError(error.message || error.getNativeError().message)))
                ),
                of(hideBusy())
            );
        })
    );
};
